import { ERequestType, fetchGetHelper } from "./fetch";

// TODO: factoriser toutes ces fonctions -> mutualiser avec fetch.js ?

export const fetchCheckout = async (restoId, restoName, type, amount, nb, source, crid, email, name) => {
	const response = await fetchGetHelper(
		ERequestType.STRIPE.CHECKOUT,
		`resto=${restoId}&restoName=${restoName}&type=${type}&amount=${amount}&nb=${nb}&source=${source}&crid=${crid}&email=${email}&name=${name}&host=${window.location.host}`,
	);

	const data = response?.data;
	if (!data || (Array.isArray(data) && data.length === 0)) {
		throw new Error("Error on fetchCheckoutApp NO DATA");
	}
	return data;
};

export const fetchCheckoutApp = async (restoId, restoName, type, amount, nb, source, crid, email, name, infos) => {
	const response = await fetchGetHelper(
		ERequestType.STRIPE.CHECKOUT_APP,
		`resto=${restoId}&restoName=${restoName}&type=${type}&amount=${amount}&nb=${nb}&source=${source}&crid=${crid}&email=${email}&name=${name}&infos=${infos}&host=${window.location.host}`,
	);

	const data = response?.data;
	if (!data || (Array.isArray(data) && data.length === 0)) {
		throw new Error("Error on fetchCheckoutApp NO DATA");
	}
	return data;
};

export const fetchCheckoutPAuto = async (restoId, restoName, type, amount, nb, source, crid, email, name, infos, redirect) => {
	const redirectParam = redirect ? `&redirect=${redirect}` : "";
	const response = await fetchGetHelper(
		ERequestType.STRIPE.CHECKOUT_P_AUTO,
		`resto=${restoId}&restoName=${restoName}&type=${type}&amount=${amount}&nb=${nb}&source=${source}&crid=${crid}&email=${email}&name=${name}&infos=${infos}&host=${window.location.host}${redirectParam}`,
	);

	const data = response?.data;
	if (!data || (Array.isArray(data) && data.length === 0)) {
		throw new Error("Error on fetchCheckoutPAuto NO DATA");
	}
	return data;
};

export const fetchRetriveSI = async (sid) => {
	const response = await fetchGetHelper(ERequestType.STRIPE.GET_SETUP_INTENT, `sid=${sid}`);

	const data = response?.data;
	if (!data || (Array.isArray(data) && data.length === 0)) {
		throw new Error("Error on fetchRetriveSI NO DATA");
	}
	return data;
};

export const fetchPayementIntent = async (pmId, amount, customerId, email, infos) => {
	const response = await fetchGetHelper(
		ERequestType.STRIPE.GET_PAYMENT_INTENT,
		`pm=${pmId}&amount=${amount}&customer=${customerId}&email=${email}&infos=${infos}&host=${window.location.host}`,
	);

	const data = response?.data;
	if (!data || (Array.isArray(data) && data.length === 0)) {
		throw new Error("Error on fetchPayementIntent NO DATA");
	}
	return data;
};

export const fetchCustomerInfos = async (customerId) => {
	const response = await fetchGetHelper(ERequestType.STRIPE.GET_CUSTOMER, `customer=${customerId}`);

	const data = response?.data;
	if (!data || (Array.isArray(data) && data.length === 0)) {
		throw new Error("Error on fetchCustomerInfos NO DATA");
	}
	return data;
};
